{
  "en": {
    "snippets": {
      "labels": {
        "cancel": "Cancel",
        "confirm": "Confirm",
        "create": "Create a snippet",
        "delete": "Delete",
        "edit": "Edit",
        "editTitle": "Edit snippet",
        "initMessage": "Select a snippet to preview it here.",
        "language": "Language",
        "linkable": "Type",
        "linkableClient": "Team",
        "linkableEmployee": "Personal",
        "linkablePartner": "Partner",
        "manage": "Manage your snippets",
        "manageMessage": "Or click here to manage all your snippets within the organisation settings",
        "message": "Message",
        "messageError": "Please enter a message",
        "new": "New snippet",
        "noSnippets": "You don't have snippets yet.",
        "preview": "Preview",
        "save": "Save",
        "search": "Search",
        "select": "Select",
        "snippets": "Snippets",
        "title": "Title",
        "titleError": "Please enter a title"
      }
    }
  }
}
